import { rankWith, scopeEndsWith } from '@jsonforms/core';
import { materialRenderers } from '@jsonforms/material-renderers'

import PriceRangeInput from './PriceRangeInput'
import AvatarInput from './AvatarInput'

const renderers = [
  {
    tester: rankWith(
      3,
      scopeEndsWith('priceRange')
    ),
    renderer: PriceRangeInput
  },
  {
    tester: rankWith(
      3,
      scopeEndsWith('avatar')
    ),
    renderer: AvatarInput
  },
  ...materialRenderers
]

export default renderers
